.regional-progress {
  margin-left: 28px;
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.regional-progress__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;
  font-size: var(--font-size-sm);
  color: var(--color-neutral-600);
}
.regional-progress__item--disabled {
  color: var(--color-neutral-400);
}
.regional-progress__item-name {
  line-height: 1.3;
}

.icon--success {
  color: var(--color-feedback-positive-600);
}
.icon--error {
  color: var(--color-feedback-danger-600);
}
.icon--progress {
  color: #2B83F7;
}
.icon--pending {
  color: var(--color-neutral-400);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL3BhZ2VzL0Rhc2hib2FyZC9mcmFnbWVudHMvRGV0YWlsc0dhbnR0L2ZyYWdtZW50cy9OZWdFeGVjdXRpb24vY29tcG9uZW50cy9SZWdpb25hbFByb2dyZXNzIiwic291cmNlcyI6WyJSZWdpb25hbFByb2dyZXNzLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7OztBQU1KO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFOztBQUdGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIucmVnaW9uYWwtcHJvZ3Jlc3Mge1xuICBtYXJnaW4tbGVmdDogMjhweDtcbiAgcGFkZGluZzogNHB4IDA7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGdhcDogMnB4O1xuXG4gICZfX2l0ZW0ge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBnYXA6IDhweDtcbiAgICBwYWRkaW5nOiAycHggMDtcbiAgICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1zbSk7XG4gICAgY29sb3I6IHZhcigtLWNvbG9yLW5ldXRyYWwtNjAwKTtcblxuICAgICYtLWRpc2FibGVkIHtcbiAgICAgIGNvbG9yOiB2YXIoLS1jb2xvci1uZXV0cmFsLTQwMCk7XG4gICAgfVxuXG4gICAgJi1uYW1lIHtcbiAgICAgIGxpbmUtaGVpZ2h0OiAxLjM7XG4gICAgfVxuICB9XG59XG5cbi5pY29uIHtcbiAgJi0tc3VjY2VzcyB7XG4gICAgY29sb3I6IHZhcigtLWNvbG9yLWZlZWRiYWNrLXBvc2l0aXZlLTYwMCk7XG4gIH1cblxuICAmLS1lcnJvciB7XG4gICAgY29sb3I6IHZhcigtLWNvbG9yLWZlZWRiYWNrLWRhbmdlci02MDApO1xuICB9XG5cbiAgJi0tcHJvZ3Jlc3Mge1xuICAgIGNvbG9yOiAjMkI4M0Y3O1xuICB9XG5cbiAgJi0tcGVuZGluZyB7XG4gICAgY29sb3I6IHZhcigtLWNvbG9yLW5ldXRyYWwtNDAwKTtcbiAgfVxufVxuIl19 */